/**
 * OnboardingStep3.tsx - Learning Preferences
 * Third step of the onboarding flow.
 * Collects learning skills and methods preferences.
 * Two sections: Skills (6 options) and Methods (4 options).
 */
import React from "react";
import { View } from "react-native";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import OnboardingFormSection from "./common/OnboardingFormSection";
import ChipSelector, { ChipOption } from "../../common/form/ChipSelect/ChipSelector";
import { spacingStyles } from "../../../styles/design-system";

export interface OnboardingStep3Props {
  selectedSkills: string[];
  onSkillsChange: (skills: string[]) => void;
  selectedLearningMethods: string[];
  onLearningMethodsChange: (methods: string[]) => void;
}

const skillOptions: ChipOption[] = [
  { key: "problem_solving", value: "Problem Solving" },
  { key: "exam_prep", value: "Exam Prep" },
  { key: "writing", value: "Writing" },
  { key: "coding", value: "Coding" },
  { key: "memorization", value: "Memorization" },
  { key: "time_management", value: "Time Management" },
];

const learningMethodOptions: ChipOption[] = [
  { key: "practice_problems", value: "Practice Problems" },
  { key: "step_by_step", value: "Step-by-Step Explanations" },
  { key: "visual_examples", value: "Visual Examples" },
  { key: "quick_summaries", value: "Quick Summaries" },
];

function OnboardingStep3({
  selectedSkills,
  onSkillsChange,
  selectedLearningMethods,
  onLearningMethodsChange,
}: OnboardingStep3Props) {
  return (
    <View style={[spacingStyles.mNone]}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step3_title"
        subtitleKey="companion_onboarding_step3_subtitle"
      />

      <OnboardingFormSection labelKey="companion_onboarding_step3_skills_label" isUppercase>
        <ChipSelector
          options={skillOptions}
          selectedKeys={selectedSkills}
          onSelectionChange={onSkillsChange}
          multiSelect
        />
      </OnboardingFormSection>

      <OnboardingFormSection labelKey="companion_onboarding_step3_methods_label" isUppercase>
        <ChipSelector
          options={learningMethodOptions}
          selectedKeys={selectedLearningMethods}
          onSelectionChange={onLearningMethodsChange}
          multiSelect
        />
      </OnboardingFormSection>
    </View>
  );
}

export default OnboardingStep3;
